import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IEvent, IUnsubscribeFromEvents } from "./types"
import api from "services/api"

export function useMemberEventsFilters() {
  return useQuery([
    "operation",
    "administration",
    "members",
    "portal",
    "filters",
  ])
}

export function useEvent(eventId: string, config?: UseQueryOptions<IEvent>) {
  return useQuery<IEvent>(["operation", "production", "events", eventId], {
    ...config,
  })
}

export function useUnsubscribeFromEvents(
  memberId: string,
  config?: UseMutationOptions<unknown, unknown, IUnsubscribeFromEvents>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, IUnsubscribeFromEvents>(
    (data) =>
      api.post(
        `operation/administration/members/${memberId}/events/unsubscribe`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          memberId,
          "events",
        ])
      },
    }
  )
}
